import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Alert from "@mui/material/Alert";
import { alertActions } from "../redux/actions/alert.actions";
import { storeStateType } from "../redux/store";

const FlashMessage = () => {
  const dispatch = useDispatch();
  const flashMessge = useSelector((state: storeStateType) => state.alert);

  useEffect(() => {
    const triggerFadeOut = () => {
      setTimeout(() => {
        dispatch(alertActions.clear());
      }, 1000);
    };
    if (flashMessge.message) {
      setTimeout(triggerFadeOut, 3000);
    }
  }, [flashMessge, dispatch]);

  return flashMessge.message ? (
    <Alert severity={flashMessge.type}>{flashMessge.message}</Alert>
  ) : (
    <></>
  );
};

export default FlashMessage;
